var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"spinner"},[_c('div',{staticClass:"clip",staticStyle:{"background":"transparent","border-style":"solid","border-radius":"100%"},style:(_vm.clipStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }